/**
 * Created by Mattias on 2015-01-23.
 */



/**
 * Created by Mattias on 2014-10-09.
 */
define('payment/handlers/sendHandlers/internalPanelHandler',['jquery', 'boxes/helpers/box-loading'],

    function($, boxLoading) {
        'use strict';

        function init() {}

        function handleSuccessfulResponse(paymentBox, sendHandlerData, accHistRef, paymentFetchResultFlow) {
            var internalPanelInformation = sendHandlerData;
            window.top.dialog.flow(internalPanelInformation.flow, {GSON_PARAMETER: internalPanelInformation.pageGsonParameter}, function(){}, function(){
                boxLoading.removeLoading(paymentBox.$box);
            });
        }

        function cleanupOnFail() {}

        var internalPanelHandler = {};
        internalPanelHandler.init = init;
        internalPanelHandler.handleSuccessfulResponse = handleSuccessfulResponse;
        internalPanelHandler.cleanupOnFail = cleanupOnFail;

        return internalPanelHandler;
    }
);
